import React from 'react';
import { Outlet, Navigate } from 'react-router';
import { useUserStore } from '@/hooks/UserStoreContext';
import { User } from '@/types/user';

interface PermissionRouteProps {
  children: React.ReactNode;
  permissionCheck?: (user: User) => boolean;
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
  children,
  permissionCheck,
}) => {
  const user = useUserStore(x => x.user);

  if (!permissionCheck) return <Outlet />;

  if (permissionCheck(user)) {
    return children ? <>{children}</> : <Outlet />;
  }

  return <Navigate to="/unauthorized" replace />;
};
